import { render, staticRenderFns } from "./WhatsIncludedScreen.vue?vue&type=template&id=16553d50"
import script from "./WhatsIncludedScreen.vue?vue&type=script&lang=js"
export * from "./WhatsIncludedScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports